import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { ERRORTYPES, ENVIRONMENT } from '../constants';
import Styles from './captcha.module.scss';
import getEnvVariable from '../utils/environment';
import withAccountInputs from '../containers/withAccountInputsV1';
import { WriteSelectors } from './captcha-qa-hooks';

export class Captcha extends PureComponent {
  render() {
    return (
      <div className={Styles.wrapper}>
        <div
          className={
          this.props.formInputs.captcha_errorType !== ERRORTYPES.NO_TYPE_SET
          && this.props.formInputs.captcha_errorType
            ? `${Styles['signup-captcha']} ${Styles['captcha-error']}`
            : Styles['signup-captcha']
        }
          data-role="captcha-container"
        >
          <ReCAPTCHA
            sitekey={getEnvVariable(ENVIRONMENT.RECAPTCHA_SITE_KEY)}
            data-role="captcha"
            onChange={this.props.postRecaptcha}
            {...WriteSelectors.captchaCheckbox}
          />
          <p className="small error">{this.props.formInputs.captcha_errorType}</p>
        </div>
      </div>
    );
  }
}

Captcha.propTypes = {
  postRecaptcha: PropTypes.func.isRequired,
  formInputs: PropTypes.shape({
    captcha_errorType: PropTypes.string,
  }).isRequired,
};

const ConnectedCaptcha = withAccountInputs(Captcha);
export default ConnectedCaptcha;
